import { render, staticRenderFns } from "./Settlement.vue?vue&type=template&id=6cd0865a&scoped=true&"
import script from "./Settlement.vue?vue&type=script&lang=js&"
export * from "./Settlement.vue?vue&type=script&lang=js&"
import style0 from "./Settlement.vue?vue&type=style&index=0&id=6cd0865a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd0865a",
  null
  
)

export default component.exports